import { Input } from 'antd'
import { FC, useState } from 'react'
import { TChatHistoryList } from 'features/chat/types'
import useFetchPage2 from 'hooks/useFetchPage2'
import useChat from 'features/chat/hooks/useChat'
import ChatHistoryList from './ChatHistoryList'

const ChatHistoryScreen: FC = () => {
 const { state } = useChat()
 const [keyword, setKeyword] = useState('')
 const {
  flatData,
  isLoading,
  fetchMore,
  hasMore,
  total,
  isRefetching,
  isFetchingNextPage,
 } = useFetchPage2<TChatHistoryList>('chat/list', {
  params: `${keyword !== '' ? `search=${keyword}` : ''}`,
  refetchOnMount: true,
  //  key: `list-${keyword}`,
 })

 return (
  <div className="chat-history-sec">
   <div className="chat-hi-search">
    <Input
     prefix={<i className="far fa-search" />}
     placeholder="Search Name"
     value={keyword}
     onChange={({ target }) => setKeyword(target.value)}
    />
   </div>
   <div className="chat-hi-body">
    <div className="chat-list-area">
     <ChatHistoryList
      data={flatData}
      isLoading={isLoading || (isRefetching && !isFetchingNextPage)}
      fetchMore={fetchMore}
      hasMore={hasMore}
      total={total}
     />
    </div>
   </div>
  </div>
 )
}

export default ChatHistoryScreen
